/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Slug_Hint1Inputs */

const vi_cmspost_slug_hint1 = /** @type {(inputs: Cmspost_Slug_Hint1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Để trống sẽ tự tạo từ tiêu đề. Đổi đường dẫn bài đã đăng thì link cũ sẽ không còn mở được.`)
};

/**

* @param {Cmspost_Slug_Hint1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_slug_hint1 = /** @type {((inputs?: Cmspost_Slug_Hint1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Slug_Hint1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_slug_hint1(inputs)
});
export { cmspost_slug_hint1 as "cmsPost_slug_hint" }